import { AgencyRoutes } from "../pages/agency/agency.route";
import { AgencySettingsRoutes } from "../pages/agency_settings/agency_settings.route";
import { AgencyUserRoutes } from "../pages/agency_user/agency_user.route";
import { AgencyWaRoutes } from "../pages/agency_wa/agency_wa.route";
import { AttendanceRoutes } from "../pages/attendance/attendance.route";
import { AttendanceSubmissionRoutes } from "../pages/attendance_submission/attendance_submission.route";
import { DashboardRoutes } from "../pages/dashboard/dashboard.route";
import { DebugToolsRoutes } from "../pages/debug_tools/debug_tools.route";
import { DeviceRoutes } from "../pages/device/device.route";
import { DevtoolsRoutes } from "../pages/devtools/devtools.route";
import { GroupRoutes } from "../pages/group/group.route";
import { default as NotFoundPage } from "../pages/NotFoundPage.vue";
import { ProfileRoutes } from "../pages/profile/profile.route";
import { ScheduleGlobalRoutes } from "../pages/schedule_global/schedule_global.route";
import { ScheduleGroupRoutes } from "../pages/schedule_group/schedule_group.route";
import { SettingsRoutes } from "../pages/settings/settings.route";
import { UserAttendanceRoutes } from "../pages/user_attendance/user_attendance.route";
import { UserBioRoutes } from "../pages/user_bio/user_bio.route";
import { UserDeviceBindingRoutes } from "../pages/user_device_binding/user_device_binding.route";
import { UserLocationRoutes } from "../pages/user_location/user_location.route";

export const routes = [
    { path: "/signin", component: () => import("../pages/LoginPage.vue") },
    {
        path: "/privacy-policy-employee",
        component: () => import("../pages/PrivacyPolicyEmployee.vue"),
    },
    {
        path: "/terms-of-service-employee",
        component: () => import("../pages/TermsOfServiceEmployee.vue"),
    },
    {
        path: "/mobile-support-employee",
        component: () => import("../pages/MobileSupportEmployee.vue"),
    },
    {
        path: "/",
        component: () => import("../pages/MainPage.vue"),
        children: [
            ...AgencyRoutes.routes,
            ...AgencySettingsRoutes.routes,
            ...AgencyUserRoutes.routes,
            ...AgencyWaRoutes.routes,
            ...AttendanceRoutes.routes,
            ...AttendanceSubmissionRoutes.routes,
            ...DashboardRoutes.routes,
            ...DebugToolsRoutes.routes,
            ...DeviceRoutes.routes,
            ...DevtoolsRoutes.routes,
            ...GroupRoutes.routes,
            ...ProfileRoutes.routes,
            ...ScheduleGlobalRoutes.routes,
            ...ScheduleGroupRoutes.routes,
            ...SettingsRoutes.routes,
            ...UserAttendanceRoutes.routes,
            ...UserBioRoutes.routes,
            ...UserDeviceBindingRoutes.routes,
            ...UserLocationRoutes.routes,
        ],
    },
    {
        path: "/:pathMatch(.*)*",
        component: NotFoundPage,
    },
];
